/**
 * Tarjeta viajera de ejemplo para invitados.
 * Estilo y frase se pueden probar en local; guardar/exportar pide cuenta.
 */

import { DEMO_PASSPORT_COUNTRIES } from "./demoPassport";

export const DEMO_TRAVEL_CARD = {
	name: "Viajero",
	phrase: "Coleccionando sellos, no recuerdos sueltos",
	styleId: "bg-8",
	createdAt: 0,
	isDemo: true,
};

export const DEMO_TRAVEL_CARD_COUNTRIES = DEMO_PASSPORT_COUNTRIES;
